var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authorize-device-page"},[_c('div',{staticClass:"authorizing-text"},[_vm._v(_vm._s(_vm.$t('auth.authorizingDevice'))+"...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }